var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-breadcrumb',{attrs:{"menu":[{label: _vm.userId ? '编辑核心企业账号' : '新增核心企业账号'}]}}),_vm._v(" "),_c('form-build',{attrs:{"form-name":"form","form-columns":_vm.formColumns,"form-rules":_vm.formRules,"form-data":_vm.form,"form-buttons":_vm.formButtons}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c79e6858","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/lender/CustomerAdmin/DebtorUserEdit.vue
// module id = null
// module chunks = 